module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
__p+='\n<nav class="navbar navbar-default bar-light">\n    ';
 } else {
__p+='\n    <nav class="navbar">\n        ';
 } 
__p+='\n        <div class="">\n            <div class="navbar-header">\n                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"\n                        aria-expanded="false" aria-controls="navbar">\n                    <span class="sr-only">Toggle navigation</span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                </button>\n                <a href="#">\n                    ';
 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
__p+='\n                    <img class="img-responsive img-top-logo" src="' + require("C:\\dev\\RNS2\\ReviewAndSignUi\\node_modules\\underscore-template-loader\\file-loader.js?url=..%2F..%2F..%2Fimages%2Flogo125x44.png!../../../images/logo125x44.png") + '"/>\n                    ';
 } else {
__p+='\n                    <img class="img-responsive img-top-logo" src="' + require("C:\\dev\\RNS2\\ReviewAndSignUi\\node_modules\\underscore-template-loader\\file-loader.js?url=..%2F..%2F..%2Fimages%2Flogo200x71.png!../../../images/logo200x71.png") + '"/>\n                    ';
 } 
__p+='\n                </a>\n                ';
 if (typeof(id) === "undefined" || typeof(person) === "undefined") { 
__p+='\n                <p class="text-muted form-group col-md-7">\n                    Main Phone Number: 833-2ASKRNS (833-227-5767) &emsp;&emsp;\n                    Main Fax Number: 833-2FAXRNS (833-232-9767)\n                </p>\n                ';
 } 
__p+='\n            </div>\n            <div id="navbar" class="collapse navbar-collapse">\n                <ul class="nav navbar-nav">\n\n                    ';
 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
__p+='\n                    ';
 for (var item in menuItems) { 
__p+='\n                    ';
 if (menuItems[item].submenus && menuItems[item].submenus.length > 0) { 
__p+='\n                    <li class="'+
((__t=( menuItems[item].activeClass ))==null?'':__t)+
'">\n                        <a href="#" class="dropdown-toggle" id="'+
((__t=( menuItems[item].title ))==null?'':__t)+
'" data-toggle="dropdown"\n                           role="button" aria-haspopup="true" aria-expanded="false">\n                            <span>'+
((__t=( menuItems[item].title ))==null?'':__t)+
'</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="'+
((__t=( menuItems[item].title ))==null?'':__t)+
'">\n                            ';
 for (var sub in menuItems[item].submenus) { 
__p+='\n                            <li><a href="'+
((__t=( menuItems[item].submenus[sub].url ))==null?'':__t)+
'">'+
((__t=(
                                menuItems[item].submenus[sub].title ))==null?'':__t)+
'</a></li>\n                            ';
 } 
__p+='\n\n                        </ul>\n                    </li>\n                    ';
 } else { 
__p+='\n                    <li class="'+
((__t=( menuItems[item].activeClass ))==null?'':__t)+
'">\n                        <a href="'+
((__t=( menuItems[item].url ))==null?'':__t)+
'">'+
((__t=( menuItems[item].title ))==null?'':__t)+
'</a>\n                    </li>\n                    ';
 } 
__p+='\n                    ';
 } 
__p+='\n                    ';
 } 
__p+='\n\n                </ul>\n                <ul class="nav navbar-nav navbar-right">\n                    ';
 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
__p+='\n                    <li class="dropdown">\n                        <a href="#" class="dropdown-toggle" id="drop2" data-toggle="dropdown" role="button"\n                           aria-haspopup="true" aria-expanded="false">\n                            <span class="date">View</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="drop2">\n                            <li><a id="set-initial-for-me" class="clickable">Set current view as initial for me</a></li>\n                            ';
 if (isAdmin) { 
__p+='\n                            <li role="separator" class="divider"></li>\n                            <li><a id="set-initial" class="clickable">Set current view as initial for</a></li>\n                            ';
 } 
__p+='\n                        </ul>\n                    </li>\n                    <li id="user-menu" class="dropdown">\n                        <a href="#" class="dropdown-toggle" id="drop3" data-toggle="dropdown" role="button"\n                           aria-haspopup="true" aria-expanded="false">\n                            <span class="date">'+
((__t=( person.firstName ))==null?'':_.escape(__t))+
' '+
((__t=( person.lastName ))==null?'':_.escape(__t))+
'</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="drop3">\n                            <li><a href="/#person/'+
((__t=( person.login ))==null?'':_.escape(__t))+
'">Profile</a></li>\n                            <li role="separator" class="divider"></li>\n                            <li><a href="#login" id="logout">Log out</a></li>\n                        </ul>\n                    </li>\n                    ';
 } else {
__p+='\n                    <li class="login-header-link"><a href="/#login">Log in</a></li>\n                    ';
 } 
__p+='\n                </ul>\n            </div>\n\n        </div>\n    </nav>\n    <div id="initial-view-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/layout/header.html
// module id = 202
// module chunks = 0